<template>
  <layout
    :titlePage="`Transferir por ${title}`"
    :route="{ name: 'carteira-saque' }"
  >
    <SubmenuBack v-if="hasToShowNewMenu" />
    <section class="pix-register-account">
      <div
        class="columns columns--full is-vcentered pix-register-account--full-width"
      >
        <div class="column is-two-fifths pix-register-account--header">
          <base-header-page
            class="c-base-header-page--full pix-register-account__header-page"
          >
            <base-icon name="pix" width="160px" height="40px" />
          </base-header-page>
        </div>
        <div class="column c-base-header-page--full margin-left-15">
          <h6 class="c-screen-middle-title" v-if="hasToShowNewMenu">
            Cadastrar chave Pix
          </h6>
          <div class="pix-register-account__steps-pix">
            <BaseSteps :steps="steps" :content="'pix'" />
          </div>
          <ChooseOwnerPixKey
            title="Selecione o titular da conta"
            subtitle="Somente contas de mesma titularidade do casal poderão receber a transferência."
            :content="getUsers()"
          />
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import SubmenuBack from '@/layouts/parts/SubmenuBack.vue'
import BaseHeaderPage from '@/components/BaseHeaderPage.vue'
import ChooseOwnerPixKey from '@/components/Wallet/Pix/List/ChooseOwnerPixKey.vue'

import BaseSteps from '@/components/Wallet/BaseSteps.vue'

export default {
  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
    walletSummary: {
      get() {
        return this.$store.state.wallet.walletSummary
      },
      set(payload) {
        this.$store.dispatch('setWalletSummary', payload)
      },
    },

    hasToShowNewMenu() {
      return this.$store.state.app.wedSiteInfo.site_menu_versao ? true : false
    },
  },

  created() {
    this.walletSummary.loading || !this.walletSummary.owner_full_name
      ? this.$router.push({ name: 'carteira' })
      : this.getUsers()
  },

  data() {
    return {
      title: 'chave PIX',
      typeRegister: 'Chave PIX',
      steps: [],
    }
  },
  components: {
    layout,
    SubmenuBack,
    BaseHeaderPage,
    BaseSteps,
    ChooseOwnerPixKey,
  },

  mounted() {
    this.tranferType(this.$route.params.transfer)
  },

  methods: {
    tranferType(transfer) {
      if (transfer == 'cc') {
        this.title = 'dados bancários'
        this.typeRegister = 'Conta bancária'
      }

      this.steps = [
        {
          step: 'Titular',
          active: true,
        },
        {
          step: this.typeRegister,
          active: false,
        },
        {
          step: 'Valor',
          active: false,
        },
        {
          step: 'Conclusão',
        },
      ]
    },

    getUsers() {
      const users = []

      users.push({
        name: this.walletSummary.owner_full_name,
        cpf: this.walletSummary.owner_cpf,
      })

      if (
        this.walletSummary.owner_full_name2 &&
        this.walletSummary.owner_cpf2
      ) {
        users.push({
          name: this.walletSummary.owner_full_name2,
          cpf: this.walletSummary.owner_cpf2,
        })
      }

      return users
    },
  },
}
</script>

<style lang="scss">
.pix-register-account {
  &__header-page {
    background-color: $support;
    @media (min-width: $tablet) {
      .svg-icon {
        width: 260px;
        height: 80px;
      }
    }
  }

  &--header {
    max-width: 582px;
  }

  &--full-width {
    width: 100%;
    margin: 0px;

    .column {
      padding: 0;
    }

    @media (min-width: $tablet) {
      margin-left: -0.75rem;
    }
  }

  &__steps-pix {
    border-bottom: 1px solid $gray-3;
    margin: 0 20px;
  }
}

.margin-left-15 {
  @media (min-width: $desktop) {
    margin-left: 15px;
  }
}
</style>
